import { render, staticRenderFns } from "./WebglBackground.vue?vue&type=template&id=7b2fbbc8&"
import script from "./WebglBackground.vue?vue&type=script&lang=js&"
export * from "./WebglBackground.vue?vue&type=script&lang=js&"
import style0 from "./WebglBackground.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports